export enum CrmSegment {
  AbandonedCarts = 'ABANDONED_CARTS',
  Cancelled = 'CANCELLED',
  ExclusiveBuyers = 'EXCLUSIVE_BUYERS',
  FreeOffers = 'FREE_OFFERS',
  Leads = 'LEADS',
  Subscribed = 'SUBSCRIBED',
}
